import { render, staticRenderFns } from "./DictItemList.vue?vue&type=template&id=09429574&scoped=true&"
import script from "./DictItemList.vue?vue&type=script&lang=js&"
export * from "./DictItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09429574",
  null
  
)

export default component.exports